import React from 'react';

const CallOut = ({ title, description, type = 'info' }) => {
    // Mapping types to your modern color palette
    const colors = {
        info: { bg: '#EEF2FF', border: '#C7D2FE', text: '#4F46E5' },
        success: { bg: '#F0FDF4', border: '#BBF7D0', text: '#16A34A' },
        danger: { bg: '#FEF2F2', border: '#FECACA', text: '#DC2626' }
    };

    const theme = colors[type] || colors.info;

    return (
        <div style={{
            backgroundColor: theme.bg,
            border: `1px solid ${theme.border}`,
            borderRadius: '12px',
            padding: '16px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px'
        }}>
            <div style={{ marginTop: '2px' }}>
                <i className={`fa ${type === 'danger' ? 'fa-exclamation-circle' : 'fa-info-circle'}`} 
                   style={{ color: theme.text, fontSize: '18px' }}></i>
            </div>
            <div>
                <h6 style={{ 
                    fontWeight: '700', 
                    fontSize: '14px', 
                    color: '#1A202C', 
                    marginBottom: '4px',
                    margin: 0 
                }}>
                    {title}
                </h6>
                <p style={{ 
                    fontSize: '13px', 
                    color: '#4A5568', 
                    margin: 0,
                    lineHeight: '1.5' 
                }}>
                    {description}
                </p>
            </div>
        </div>
    );
};

export default CallOut;